module.exports = "/images/sale-double.svg";